module.exports = __webpack_public_path__ + "img/serve_03@2x.7b4ef1a0.png";